import AttachmentsPopup from "./attachments-popup";

export default AttachmentsPopup;